import { Injectable } from '@angular/core';
import { CounterWidgetDataEntryEndUserDto } from '@osos/shared/api';
import { CounterUserEntryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { CounterUserEntryParserV1Service } from '../../parsers/counter-user-entry-parser/counter-user-entry-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class CounterUserEntryFactoryService extends FactoryBase<
  CounterWidgetDataEntryEndUserDto,
  CounterUserEntryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: CounterUserEntryParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: CounterUserEntryPresenterModel,
  ): CounterWidgetDataEntryEndUserDto {
    const parser = this.getParser(
      CounterWidgetDataEntryEndUserDto,
      CounterUserEntryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: CounterWidgetDataEntryEndUserDto,
  ): CounterUserEntryPresenterModel {
    const parser = this.getParser(
      CounterWidgetDataEntryEndUserDto,
      CounterUserEntryPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
